export default "__VITE_ASSET__e92b9431__"